module.exports = __webpack_public_path__ + "img/class-certificate.b0c02c4b.png";